<template>
    <div>
        <Row :gutter="16" style="margin-bottom: 24px">
            <Col span="4">
                <Input placeholder="版本名称" v-model="search.version_name" clearable />
            </Col>
            <Col span="6">
                <Button type="primary" icon="ios-search-outline" @click="searchList">搜索</Button>
            </Col>
        </Row>
        <Row :gutter="16" style="margin-bottom: 24px">
            <Col span="6">
                <Button icon="md-add" type="primary" @click="addPackage">新增套餐</Button>
            </Col>
        </Row>
        <Table :columns="columns" :data="tableData" :loading="loading" border>
            <template slot-scope="{ row }" slot="permissions_name">
                {{ getPermissionLabel(row.permissions_id) }}
            </template>
            <template slot-scope="{ row }" slot="price">
                {{ formatPrice(row) }}
            </template>
            <template slot-scope="{ row }" slot="auth_info">
                {{ formatAuth(row) }}
            </template>
            <template slot-scope="{ row }" slot="extra_features">
                <div>
                    {{ row.extra_features || '-' }}
                </div>
            </template>
            <template slot-scope="{ row }" slot="status">
                <i-switch
                    v-model="row.status"
                    :true-value="1"
                    :false-value="2"
                    size="large"
                    @on-change="changeStatus(row)"
                >
                    <span slot="open">已上架</span>
                    <span slot="close">已下架</span>
                </i-switch>
            </template>
            <template slot-scope="{ row }" slot="operation">
                <Button type="primary" size="small" style="margin-right: 5px" @click="editPackage(row)">编辑</Button>
                <Button type="error" size="small" @click="removePackage(row.id)">删除</Button>
            </template>
        </Table>
        <br />
        <Page
            :total="total"
            :current="search.page"
            style="text-align:right"
            show-elevator
            show-total
            :page-size="search.limit"
            @on-change="pageChange"
        />
    </div>
</template>

<script>
import { version_get_list, version_delete, version_update_status, version_permission_list } from '@/api/versionPackage'

export default {
    name: 'versionPackage',
    data() {
        return {
            loading: false,
            tableData: [],
            total: 0,
            permissionsList: [],
            search: {
                limit: 20,
                page: 1,
                version_name: ''
            },
            columns: [
                { title: '#', key: 'id', width: 80, align: 'center' },
                { title: '版本名称', key: 'version_name', align: 'center' },
                { title: '简介', key: 'description', align: 'center', ellipsis: true, tooltip: true },
                { title: '版本权限', slot: 'permissions_name', align: 'center' },
                { title: '价格', slot: 'price', align: 'center', width: 160 },
                { title: '授权', slot: 'auth_info', align: 'center', width: 120 },
                { title: '赠送短信', key: 'gift_sms', align: 'center', width: 100 },
                { title: '次年费用', key: 'renewal_fee', align: 'center', width: 100 },
                { title: '附加功能', slot: 'extra_features', align: 'center',  },
                { title: '应用状态', slot: 'status', align: 'center', width: 120 },
                { title: '操作', slot: 'operation', align: 'center', width: 180 }
            ]
        }
    },
    created() {
        this.loadPermissions()
        this.getList()
    },
    methods: {
        loadPermissions() {
            version_permission_list().then(res => {
                const pageData = (res && res.data) || {}
                this.permissionsList = pageData.data || []
            }).catch(() => {
                this.permissionsList = []
            })
        },
        getPermissionLabel(id) {
            const item = this.permissionsList.find(row => String(row.id) === String(id))
            return item ? item.version_name : '-'
        },
        formatPrice(row) {
            const price = row.price != null && row.price !== '' ? `${row.price}元` : '-'
            const original = row.original_price != null && row.original_price !== '' ? `原价${row.original_price}元` : ''
            return original ? `${price} / ${original}` : price
        },
        formatAuth(row) {
            if (Number(row.is_permanent) === 1) return '终生'
            const years = row.year_num != null && row.year_num !== '' ? row.year_num : '-'
            return `${years}年`
        },
        getList() {
            this.loading = true
            version_get_list({
                page: this.search.page,
                limit: this.search.limit,
                version_name: this.search.version_name || ''
            }).then(res => {
                const pageData = (res && res.data) || {}
                this.tableData = pageData.data || []
                this.total = Number(pageData.total) || 0
            }).catch(res => {
                this.tableData = []
                this.total = 0
                this.$Message.error((res && res.msg) || '获取版本列表失败')
            }).finally(() => {
                this.loading = false
            })
        },
        pageChange(page) {
            this.search.page = page
            this.getList()
        },
        searchList() {
            this.search.page = 1
            this.getList()
        },
        addPackage() {
            this.$router.push({ path: '/admin/versionPackage/info', query: { run: 'add' } })
        },
        editPackage(row) {
            sessionStorage.setItem('versionPackageEditRow', JSON.stringify(row))
            this.$router.push({
                path: '/admin/versionPackage/info',
                query: { run: 'edit', id: row.id }
            })
        },
        changeStatus(row) {
            version_update_status({ id: row.id, status: row.status }).then(res => {
                this.$Message.success(res.msg)
                this.getList()
            }).catch(res => {
                this.$Message.error((res && res.msg) || '状态更新失败')
                this.getList()
            })
        },
        removePackage(id) {
            this.$Modal.confirm({
                title: '删除版本',
                content: '请问您是否确认删除该版本？',
                onOk: () => {
                    version_delete({ id }).then(res => {
                        this.$Message.success(res.msg)
                        this.getList()
                    }).catch(res => {
                        this.$Message.error((res && res.msg) || '删除失败')
                    })
                }
            })
        }
    }
}
</script>

<style scoped>
::v-deep .ivu-switch-large.ivu-switch-checked::after {
    left: 45px;
}
::v-deep .ivu-switch-large {
    width: 66px;
}
</style>
